
















































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StudentQuestionAnswersModule = namespace("student-question-answers");

@Component({
  components: {},
})
export default class StudentQuestionsImgNeutral extends Vue {
  @Prop()
  public studentEducation!: any;
  @Prop()
  public learningMode!: any;
  @Prop()
  public stats: any;
  @Prop()
  public loading: any;

  get incorrectlyAnsweredX(): number {
    if (!this.stats || !this.stats.incorrectlyAnswered) {
      return -21;
    }
    if (this.stats.incorrectlyAnswered >= 100) {
      return -42;
    }
    if (this.stats.incorrectlyAnswered >= 10) {
      return -32;
    }
    return -21;
  }

  get readyForExamX(): number {
    if (!this.stats || !this.stats.readyForExam) {
      return -16;
    }
    if (this.stats.readyForExam >= 100) {
      return -36;
    }
    if (this.stats.readyForExam >= 10) {
      return -26;
    }
    return -16;
  }

  get oneTimeAnsweredX(): number {
    if (!this.stats || !this.stats.correctlyAnswered) {
      return 17;
    }
    if (this.stats.correctlyAnswered >= 100) {
      return -3;
    }
    if (this.stats.correctlyAnswered >= 10) {
      return 7;
    }
    return 17;
  }

  get remainingMidX(): number {
    if (!this.stats || !this.stats.remaining) {
      return 18;
    }
    if (this.stats.remaining >= 1000) {
      return -12;
    }
    if (this.stats.remaining >= 100) {
      return -2;
    }
    if (this.stats.remaining >= 10) {
      return 7;
    }
    return 18;
  }

  get remainingX(): number {
    if (!this.stats || !this.stats.remaining) {
      return 18;
    }
    if (this.stats.remaining >= 1000) {
      return -12;
    }
    if (this.stats.remaining >= 100) {
      return -2;
    }
    if (this.stats.remaining >= 10) {
      return 7;
    }
    return 18;
  }
}
